import {staticResourcesEndpoint} from "../../../utils/communication";
import {Link} from "react-router-dom";
import React from "react";
import HFImage from "../../hf-image";

export default function RecipeCard({recipe, needsSeparator = false}: { recipe: Recipe, needsSeparator: boolean}) {
    return (
        <div key={recipe.publicId} className={"flex py-4 " + (needsSeparator ? "border-b-[1px] border-gray-300 dark:border-gray-700" : "")}>
            <HFImage
                src={staticResourcesEndpoint + "/static/hfsitedata/cookinghf/" + recipe.publicId + ".JPG"}
                alt={recipe.name}
                className="w-32 h-32 rounded-lg mr-8 object-cover bg-8"/>

            <div className="info flex-1">
                <div className="title font-bold text-lg leading-6">
                    <Link to={"/cooking/recipe/" + recipe.publicId}>
                        {recipe.name}
                    </Link>
                </div>
                <div
                    className="description text-4 text-xs">{recipe.cuisineType?.name ?? "Unknown Cuisine Type"}</div>
                <div className="description text-4 pt-2">{recipe.description}</div>
            </div>
        </div>
    );
}